<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocf"><a class="xref" href="#/chilowy0006#intro"><span class="sm">INTRODUCTION</span> / “To See What Is about to Be Born”</a></p>
<p class="toc"><a class="xref" href="#/chilowy0007#ch01"><span class="sm">ONE</span> / The Liminal Fetus</a></p>
<p class="toc"><a class="xref" href="#/chilowy0008#ch02"><span class="sm">TWO</span> / Genetics, Morphology, and Difficult Diagnoses</a></p>
<p class="toc"><a class="xref" href="#/chilowy0009#ch03"><span class="sm">THREE</span> / Diagnostic Puzzles: Fetopathology in France</a></p>
<p class="toc"><a class="xref" href="#/chilowy0010#ch04"><span class="sm">FOUR</span> / Visible Disasters: Fetopathology in Brazil</a></p>
<p class="toc"><a class="xref" href="#/chilowy0011#ch05"><span class="sm">FIVE</span> / Balancing Risks: PND and the “Prevention of Disability”</a></p>
<p class="toc"><a class="xref" href="#/chilowy0012#ch06"><span class="sm">SIX</span> / PND, Reproductive Choices, and Care</a></p>
<p class="toc"><a class="xref" href="#/chilowy0013#conc"><span class="sm">CONCLUSION</span> / A Nonscrutinized Diagnosis</a></p>
<p class="toc"><a class="xref" href="#/chilowy0014#ch07"><span class="sm">CODA</span> / Minerva’s Owl and Apollo’s Lyre</a></p>
<p class="tocbmf"><a class="xref" href="#/chilowy0015#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chilowy0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chilowy0018#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chilowy0019#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lowy-0005.vue?69e8a047